<div class="container  fw-b ">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
    <p class="text-muted mt-2 mb-0">
      Your saved items will appear here for quick access later.
    </p>
  </div>
<div class="container mb-5 wrapper-content">
  
    <div class="row  row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mt-3">
        <div class="col newCardWidth mb-3"
            *ngFor="let item of productDetails | paginate : {itemsPerPage: limit, currentPage: currentPage, totalItems: totalItems};let i = index">
            <div class="innerDiv">
                <div class="d-flex justify-content-end mb-3">
                    <!-- <img class="img" [src]="item?.productId?.thumbnail" alt=""
                        (click)="navigateToViewProduct(item?.productId?._id)"> -->
                    <span class="heart" (click)="addWishlist(item?.productId?._id)">
                        <i class="fa fa-heart-o" *ngIf="item?.isLike == false"></i>

                        <i class="fa fa-heart" style="color: red;" *ngIf="item?.isLike == true"></i>
                    </span>
                </div>
                <!-- <div class="mt-3" (click)="navigateToViewProduct(item?.productId?._id)">
                    <h3 class="text-center">{{item?.productId?.productName}}</h3>
                </div>
                <div class="mt-2" (click)="navigateToViewProduct(item?.productId?._id)">
                    <h3 class="text-center">{{item?.productId?.priceSizeDetails[0]?.price &&
                        getPrice(item?.productId?.priceSizeDetails[0]?.price | currency:"ZAR":"R")}}</h3>
                </div> -->
                <wishlist-card [data]="item" (on_Click)="navigateToViewProduct(item?.productId?._id)"></wishlist-card>
            </div>
        </div>
    </div>
    <!-- 🌟 Empty State UI updated 15/4/2025 -->
    <div *ngIf="productDetails.length == 0" class="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <svg width="160" height="160" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(30, 30)">
          <path d="M20 20H120L110 80H40L20 20Z" fill="#F9FAFB" stroke="#c8102e" stroke-width="4" stroke-linejoin="round"/>
          <circle cx="50" cy="100" r="8" fill="#c8102e"/>
          <circle cx="90" cy="100" r="8" fill="#c8102e"/>
          <circle cx="70" cy="50" r="18" fill="#c8102e"/>
          <path d="M62 45 Q70 40 78 45" stroke="#c8102e" stroke-width="2" fill="none"/>
          <circle cx="65" cy="48" r="2" fill="#c8102e"/>
          <circle cx="75" cy="48" r="2" fill="#c8102e"/>
        </g>
      </svg>
    
      <h2 class="text-xl font-semibold text-gray-900 mt-6">Empty Wishlist</h2>
      <p class="text-gray-600 mt-2">Your wishlist is currently empty</p>
      <p class="text-gray-500 mb-6">Start exploring and add your favorite products here!</p>
    
      <!-- 🛍️ Start Shopping Button -->
      <button [routerLink]="['/home']" style="margin-top: 20px; background-color: #c8102e; color: white; padding: 10px 20px; border: none; border-radius: 5px;">
        Start Shopping
      </button>
    </div>
    

    <div class="custom-pagination mt-2 text-align-right" style="text-align: right;" *ngIf="totalItems > 15">
        <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
    </div>
</div>